export enum MessageTypeEnum {
  TEXT = 'text',
  PHOTO = 'photo',
  BUTTON = 'button',
  VOICE = 'voice',
  VIDEO_NOTE = 'videoNote',
  SIGNATURE = 'signature'
}
